<template>
  <div>
    <section class="fxt-template-layout10">
      <v-container fluid class="pa-0">
        <v-layout row wrap> 
          <v-flex md6 class="col-12 fxt-bg-img" data-bg-image="../../../static/img/bg14-l.jpg">
            <div class="fxt-header">
                <div>
                    <h1 class="black--text">{{$t('header.analyst')}} </h1>
                </div>
                <div>
                    <p class="black--text">{{$t('header.paidTitle')}}</p>
                </div>
            </div>
          </v-flex>
          <v-flex md6 class="col-12 fxt-bg-color">
            <div class="fxt-content">                            
                <div class="fxt-form fxt-footer">                                                      
                    <div v-show="isShowLink">
                        <h2 class="fw-bold">{{$t("activation.hint")}}</h2>
                        <div><v-btn flat medium color="primary" @click="register">{{$t("activation.link")}}</v-btn></div>
                    </div>
                    <div v-show="isShowMessage">
                      <div class="mb-3 font-14">{{$t("activation.valid")}}</div>
                      <div>
                        <v-btn medium color="primary" @click="goHome">{{$t("allPage.homepage")}}</v-btn>
                      </div>
                    </div>
                </div> 
                <div class="fxt-footer">
                    <ul class="fxt-socials">
                        <li class="fxt-twitter fxt-transformY-50 fxt-transition-delay-7">
                            <a href="https://twitter.com/ioBots_" title="twitter"><i class="fab fa-twitter"></i></a>
                        </li>
                        <li class="fxt-twitter fxt-transformY-50 fxt-transition-delay-7">
                            <a href="https://twitter.com/ioBotsPro" title="twitter"><i class="fab fa-twitter"></i></a>
                        </li>
                        <li class="fxt-linkedin fxt-transformY-50 fxt-transition-delay-9">
                            <a href="https://t.me/iob_llc" title="Telegram"><i class="fab fa-telegram-plane"></i></a>
                        </li>
                    </ul>
                </div>
              </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>  
  </div>
</template>
<style>
</style>
<script>
import config from "../../config.js";
import $ from 'jquery';
export default {
  data() {
    return {
      isShowLink: false,
      isShowMessage: false
    };
  },
  mounted: function() {
    //浏览器窗口发生变化时同时变化DIV高度
    // window.onresize=this.autodivheight();
    this.verifyLink();
    this.background();
  },
  methods: {
    background(){
        $("[data-bg-image]").each(function() {
          var img = $(this).data("bg-image");
            $(this).css({
              backgroundImage: "url(" + img + ")"
            });
        })
    },
    //自动获得div高度
    autodivheight() {
      //函数：获取尺寸
      //获取浏览器窗口高度
      var winHeight = 0;
      if (window.innerHeight) {
        winHeight = window.innerHeight;
      } else if (document.body && document.body.clientHeight) {
        winHeight = document.body.clientHeight;
      } //通过深入Document内部对body进行检测，获取浏览器窗口高度
      if (document.documentElement && document.documentElement.clientHeight) {
        winHeight = document.documentElement.clientHeight;
      }
      //DIV高度为浏览器窗口的高度:winHeight - 66
      document.getElementById("content").style.height = winHeight + "px";
    },
    //验证链接是否有效
    verifyLink() {
      let currentUrl = window.location.href;
      let email = currentUrl.substring(
        currentUrl.indexOf("=", 1) + 1,
        currentUrl.indexOf("#", 1)
      );
      this.$http
        .get(config.baseUrl + "emailLink/open/verifyLink?regEmail=" + email)
        .then(
          successData => {
            let data = successData.data;
            if (data.resCode == 0) {
              this.isShowLink = true;
              this.isShowMessage = false;
            } else if (data.resCode == -1) {
              this.isShowLink = false;
              this.isShowMessage = true;
              this.$Notice.warning({
                title: "Warning",
                desc: "The email is not registered or has been updated. "
              });
            } else if (data.resCode == -2) {
              this.isShowLink = false;
              this.isShowMessage = true;
              this.$Notice.warning({
                title: "Warning",
                desc: "The email has been activated. "
              });
            } else if (data.resCode == -3) {
              this.isShowLink = false;
              this.isShowMessage = true;
              this.$Notice.warning({
                title: "Warning",
                desc: "The link has timed out. "
              });
            }
          },
          errorData => {
            this.$Message.error(this.$t("common.error"));
          }
        );
    },
    //跳转成功页面
    gotoresgistersuccess() {
      this.$router.push({ name: "resgistersuccess" });
    },
    //跳转到主页
    goHome() {
      window.location.href = config.ip;
    },
    //激活
    register() {
      let url = window.location.href;
      let email = url.substring(url.indexOf("=", 1) + 1, url.indexOf("#", 1));
      let url1 =
        config.baseUrl + "user/open/register/activateEmail?regEmail=" + email;
      let that = this;
      this.$http.get(url1, this.formInline).then(
        successData => {
          let data = successData.data;
          if (data.resCode == 0) {
            this.$Message.success("success");
            this.$router.push({ name: "registersuccess" });
          } else if (data.resCode == -1) {
            this.$Message.error("The account does not exist!");
          } else if (data.resCode == -2) {
            this.$Message.error("The account has been activated!");
          } else if (data.resCode == -3) {
            this.$Message.error(this.$t("common.error"));
          } else {
            this.$router.push({ name: "activation" });
          }
        },
        errorData => {
          this.$Message.error(this.$t("common.error"));
        }
      );
    }
  }
};
</script>


// WEBPACK FOOTER //
// Activation.vue?8dcbfcb4